import { Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Layout from './components/layout/Layout'
import HomePage from './routes/HomePage'
import SubstancePage from './routes/SubstancePage'
import DuerpListPage from './routes/DuerpListPage'
import DuerpPage from './routes/DuerpPage'
import UnitePage from './routes/UnitePage'
import DuerpExportPage from './routes/DuerpExportPage'
import NotFoundPage from './routes/NotFoundPage'
// Pages légales
import MentionsLegales from './routes/MentionsLegales'
import CGU from './routes/CGU'
import Confidentialite from './routes/Confidentialite'
import Cookies from './routes/Cookies'
import LoginPage from './components/auth/LoginPage'
import { CookieBanner } from './components/legal'
import { useAuthStore } from './stores/authStore'
import { authAPI, setQuotaUpdateCallback } from './services/api'

function App() {
  const { setUser, setQuota, user, logout } = useAuthStore()
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)
  const [isServerAuthenticated, setIsServerAuthenticated] = useState(false)

  // Enregistrer le callback pour mise à jour du quota
  useEffect(() => {
    setQuotaUpdateCallback(setQuota)
  }, [setQuota])

  // Vérifier la session au chargement - TOUJOURS vérifier côté serveur
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const result = await authAPI.me()
        if (result.authenticated && result.user) {
          setUser(result.user)
          setIsServerAuthenticated(true)
        } else {
          // Serveur dit non authentifié - forcer logout local
          logout()
          setIsServerAuthenticated(false)
        }
      } catch (error) {
        // Erreur - forcer logout local
        logout()
        setIsServerAuthenticated(false)
      } finally {
        setIsCheckingAuth(false)
      }
    }

    checkAuth()
  }, [setUser, logout])

  // Afficher un loader pendant la vérification
  if (isCheckingAuth) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    )
  }

  // Si non authentifié (selon le serveur), afficher la page de connexion
  if (!isServerAuthenticated || !user) {
    return (
      <>
        <LoginPage />
        <CookieBanner />
      </>
    )
  }

  // Si authentifié, afficher l'application
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Page d'accueil */}
          <Route index element={<HomePage />} />

          {/* Fiche substance */}
          <Route path="substance/:cas" element={<SubstancePage />} />

          {/* Module DUERP */}
          <Route path="duerp" element={<DuerpListPage />} />
          <Route path="duerp/:id" element={<DuerpPage />} />
          <Route path="duerp/:id/unite/:uniteId" element={<UnitePage />} />
          <Route path="duerp/:id/export" element={<DuerpExportPage />} />

          {/* Pages légales */}
          <Route path="mentions-legales" element={<MentionsLegales />} />
          <Route path="cgu" element={<CGU />} />
          <Route path="confidentialite" element={<Confidentialite />} />
          <Route path="cookies" element={<Cookies />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>

      {/* Bandeau consentement cookies (RGPD) */}
      <CookieBanner />
    </>
  )
}

export default App
